// extracted by mini-css-extract-plugin
module.exports = {"report":"report___vUwP_"};